export default __webpack_public_path__ + "static/media/help.59d810f5.md";